import * as React from 'react';
// import {Fragment} from 'react';
import { trackAction } from '../../../utils/trackActions';

import cx from 'classnames';
import { Api } from '../../../api';

// import styles from '../../../styles/home/home.scss';
import bannerStyles from '../../../styles/home/blackBanner.scss';

export const CDN_CLEARSAVE_URL = 'https://assets1.cleartax-cdn.com';

const api = new Api();
const { Component } = React;
interface State {
  // isStorageSet: boolean;
  smsSent: boolean;
  // invalidPhone: boolean;
}

interface Props {
  isMobile: boolean;
  email: string;
}

class BannerBlack extends Component<Props, State> {
  public mobileInput: React.RefObject<any>;
  constructor(props: any) {
    super(props);
    this.state = {
      // isStorageSet: false,
      smsSent: false,
      // invalidPhone: false
    };
    this.mobileInput = React.createRef();
  }

  public componentDidMount() {
    // const { email } = this.props;
    // const bannerStorage = localStorage[email + '-black-banner'];
    // if (bannerStorage) {
    //   this.setState({
    //     isStorageSet: true,
    //   });
    // }
  }

  public async sendBlackSMS(phone: string) {
    try {
      this.setState({
        smsSent: true,
      });
      if (!this.state.smsSent) {
        const platform = this.props.isMobile ? 'mobile' : 'web';
        trackAction(
          'register-clicked',
          `black-banner-${platform}`,
          'Black-Tax-Campaign'
        );
        await api.sendBlackSMS(phone);
        await api.recordBlackSMSSheet(phone);
      }
    } catch (e) {}
  }

  private getContent() {
    // const { isMobile } = this.props;
    const countDownDate = new Date('Mar 29, 2021 14:00:00').getTime();
    const now = new Date().getTime();
    const timeLeft = countDownDate - now;
    const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));

    // TODO: Validate invalid phone numbers
    // const inputBorder = this.state.invalidPhone
    //   ? '1px solid red !important'
    //   : '1px solid !important';
    const inputBorder = '1px solid !important';
    const inputStyle = {
      border: inputBorder,
      borderRadius: '10px !important',
      fontSize: '15px !important',
      fontWeight: 100,
      color: '#808080',
    };
    return (
      // Old black banner
      // <div>
      //   <div className={cx('desktop-only', styles['black-banner-bg'])}>
      //     <div
      //       className={cx(
      //         'large-7',
      //         'medium-6',
      //         styles['black-logo-container']
      //       )}
      //     >
      //       <div className={cx(styles['ct-logo-container'])}>
      //         <img
      //           src={`${CDN_CLEARSAVE_URL}/cleartax-brand/logos/2018/01/pinchy_yellow_black.png`}
      //           alt="ClearTax"
      //           title="Home: ClearTax"
      //           height="18"
      //         />
      //         <span className={cx(styles['ctlogo-rightTxt'])}> presents</span>
      //       </div>
      //       <img
      //         className={cx(styles['black-logo'])}
      //         src={`/save/static/black-logo.svg`}
      //         alt="Black"
      //       />
      //     </div>

      //     <div
      //       className={cx(
      //         'large-5',
      //         'medium-6',
      //         styles['black-content-container']
      //       )}
      //     >
      //       <div className={cx(styles['black-banner-content'])}>
      //         The smartest investment app ever. <br />
      //         Click below to download the App!
      //       </div>
      //       <a
      //         href="http://cleartax.in/f/black-download"
      //         onClick={() => this.registerNow(isMobile)}
      //         className={cx(styles['register-btn'])}
      //       >
      //         <span className={cx(styles['register-btnTxt'])}>
      //           Download Now
      //         </span>
      //       </a>
      //     </div>
      //   </div>

      // Old mobile black banner
      // <div>
      //   <div className={cx('mobile-only', styles['mobile-black-banner-bg'])}>
      //     <div className={cx('small-7', styles['mobile-black-logo-container'])}>
      //       <img
      //         className={cx(styles['mobile-black-logo'])}
      //         src={`/save/static/black-logo.svg`}
      //         alt="Black"
      //       />
      //     </div>

      //     <div
      //       className={cx('small-5', styles['mobile-black-content-container'])}
      //     >
      //       <div className={cx(styles['mobile-black-banner-content'])}>
      //         The smartest investment app ever
      //       </div>
      //       <a
      //         href="http://cleartax.in/f/black-download"
      //         onClick={() => this.registerNow(isMobile)}
      //         className={cx(styles['mobile-black-link'])}
      //       >
      //         Click to download the App!
      //       </a>
      //     </div>
      //   </div>
      // </div>

      // Black tax banner
      <div className={bannerStyles['container']}>
        {/* Desktop Banner */}
        <div className={cx('desktop-only', bannerStyles['desktop-container'])}>
          <div className={bannerStyles['logo']}>
            <img
              src={`${CDN_CLEARSAVE_URL}/clearsave/images/1616594885_blackbycleartaxwhite.png`}
              alt="ClearTax"
              title="Home: ClearTax"
              className={bannerStyles['logo-image']}
            />
          </div>
          <div className={bannerStyles['text-container']}>
            <div className={bannerStyles['text-header']}>
              Only <span>{days} days</span> left to save taxes upto ₹46,800!
            </div>
            <div className={bannerStyles['text-subheader']}>
              Invest in tax saving direct mutual funds • Get proof instantly
            </div>
            <div className={bannerStyles['text-footer']}>
              For Non KYC users, deadline to invest is 26th March 2PM{' '}
            </div>
          </div>
          <div className={bannerStyles['cta-container']}>
            <div className={bannerStyles['invest-now-container']}>
              <a
                href="https://cleartax.in/save/plan/19"
                className={bannerStyles['invest-now-button']}
              >
                Start investing now
              </a>
            </div>
            <div className={bannerStyles['divider-container']}>
              <div className={bannerStyles['divider']}></div>
              <div className={bannerStyles['divider-text']}>or</div>
              <div className={bannerStyles['divider']}></div>
            </div>
            <div className={bannerStyles['download-container']}>
              <input
                type="text"
                placeholder="Your phone number"
                style={inputStyle}
                className={bannerStyles['download-phone']}
                ref={this.mobileInput}
              />
              <div
                onClick={() => {
                  this.sendBlackSMS(this.mobileInput.current.value);
                }}
                className={cx(
                  bannerStyles['download-button'],
                  this.state.smsSent && bannerStyles['download-button-disabled']
                )}
              >
                Get download link
              </div>
              <div className={bannerStyles['download-footer']}>
                For android users only*
              </div>
            </div>
          </div>
        </div>
        {/* Mobile Banner */}
        <div className={cx('mobile-only', bannerStyles['mobile-container'])}>
          <div className={bannerStyles['mobile-text-header']}>
            Only <span>{days} days</span> left to save taxes upto ₹46,800!
          </div>
          <a
            href="https://black-cleartax.app.link/tax-super-saver"
            className={bannerStyles['mobile-button-container']}
          >
            <img
              src={`${CDN_CLEARSAVE_URL}/clearsave/images/1616667813_playstoreicon.png`}
              alt="ClearTax"
              title="Tax Super Saver: ClearTax"
              className={bannerStyles['playstore-icon']}
            />
            <span className={bannerStyles['mobile-button-text']}>
              Download Black
            </span>
          </a>
        </div>
      </div>
    );
  }

  // private registerNow(isMobile: boolean) {
  //   const { email } = this.props;
  //   const platform = isMobile ? 'mobile' : 'web';
  //   trackAction(
  //     'register-clicked',
  //     `black-banner-${platform}`,
  //     'Black-Campaign'
  //   );
  //   const bannerStorage = localStorage[email + '-black-banner'];
  //   if (!bannerStorage) {
  //     localStorage[email + '-black-banner'] = true;
  //   }
  //   this.setState({
  //     isStorageSet: true,
  //   });
  // }

  public render() {
    // const { isStorageSet } = this.state;

    // return <Fragment>{!isStorageSet ? this.getContent() : null}</Fragment>;
    return this.getContent();
  }
}
export default BannerBlack;



// WEBPACK FOOTER //
// ./components/homePage/experimental/bannerBlack.tsx